import React, { useState } from "react";
import { Table, Modal, Tag } from "antd";
import { useSelector } from "react-redux";

const columns = [
     {
            title: "#",
            dataIndex: "key",
            key: "key",
            width: 50,
            render: (_, record, index) =>  index + 1,
        },
    {
        title: "Category Name",
        dataIndex: "categoryName",
        width: 200, // Fixed width
    },
    {
        title: "Total Transactions",
        dataIndex: "totalTransactionCount",
        width: 80, // Fixed width
    },
    {
        title: "Total Amount",
        dataIndex: "totalTransactionAmount",
        width: 80, // Fixed width
        render: (value) => value ? `₹ ${(value / 100).toFixed(2)}` : "-"
    },
    {
        title: "Total Bank Commission",
        dataIndex: "totalBankCommission",
        width: 80, // Fixed width
         render: (value) => `${value ? '₹ ' + value : '-'}`
    },
    {
        title: "Total AI Commission",
        dataIndex: "totalAgentCommission",
        width: 80, // Fixed width
        render: (value) => `${value ? '₹ ' + value : '-'}`
    }
];

const AgentTransactionDetailsModal = ({ agentTransactionModel, setAgentTransactionModel,  agentName }) => {


    const {
        loading,
        agentTransactionsDetailsResponseData
    } = useSelector((state) => ({
        agentTransactionsDetailsResponseData: state.agentDetailsReducer?.agentTransactionsDetailsResponseData,
        loading: state.agentDetailsReducer?.loading,
    }));

    return (
        <Modal
      title={`Categories wise transaction details - ${agentName}`}
            open={agentTransactionModel}
            onCancel={() => setAgentTransactionModel(false)}
            width={1000}
            maskClosable={false}
            footer={null}
        >
            <div>

                <Table
                    columns={columns}
                    dataSource={!loading ? [...(agentTransactionsDetailsResponseData || [])].sort((a, b) => b.totalTransactionCount - a.totalTransactionCount) : []
    }
                    scroll={{ x: 600 }}
                     pagination={{
            
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ["10", "20", "50"],
            defaultPageSize: 100, // Added to ensure 100 rows by default
          }}
                    loading={loading}
                />
            </div>
        </Modal>
    );
};

export default AgentTransactionDetailsModal;
